export const languages = {
  en_US: 'English',
  en_GB: 'English (UK)',
  ar: 'Arabic',
  bn: 'Bengali',
  bg: 'Bulgarian',
  zh_CN: 'Chinese (Simplified)',
  zh_TW: 'Chinese (Traditional)',
  hr: 'Croatian',
  cs: 'Czech',
  da: 'Danish',
  nl: 'Dutch',
  et: 'Estonian',
  fi: 'Finnish',
  fr: 'French',
  ka: 'Georgian',
  de: 'German',
  el: 'Greek',
  he: 'Hebrew',
  hi: 'Hindi',
  hu: 'Hungarian',
  id: 'Indonesian',
  it: 'Italian',
  ja: 'Japanese',
  ko: 'Korean',
  lv: 'Latvian',
  lt: 'Lithuanian',
  ms: 'Malay',
  ma: 'Maltese',
  ne: 'Nepali',
  no: 'Norwegian',
  fa: 'Persian',
  pl: 'Polish',
  pt: 'Portuguese',
  ro: 'Romanian',
  ru: 'Russian',
  sr: 'Serbian',
  sk: 'Slovak',
  sl: 'Slovenian',
  es: 'Spanish',
  sv: 'Swedish',
  ta: 'Tamil',
  th: 'Thai',
  tr: 'Turkish',
  uk: 'Ukrainian',
  vi: 'Vietnamese',
} as const;

// Sort languages by name
// export const sortedLanguages = Object.entries(languages)
//   .sort((a, b) => a[1].localeCompare(b[1]))
//   .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

export type Language = (typeof languages)[keyof typeof languages];
